module.exports = __webpack_public_path__ + "img/full2-min.ea01bb9a.png";